import HeroPage from "./HeroPage";
import TrustStrip from "../components/TrustStrip";
import HowItWorksPage from "./HowItWorksPage";
import FeaturesPage from "./FeaturesPage";
import BrowsePage from "./BrowsePage";
import PopularMakesSection from "../components/PopularMakesSection";
import FeaturesSection from "../components/FeaturesSection";
import DownloadSection from "../components/DownloadSection";
import TestimonialsSection from "../components/TestimonialsSection";
import AboutUsPage from "./AboutUsPage";
import FAQPage from "./FAQPage";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const Index = ({ onOpenSignup }) => {
  useScrollAnimation();

  return (
    <div>
      <main>
        <HeroPage onOpenSignup={onOpenSignup} />
        <TrustStrip />
        <HowItWorksPage />
        <FeaturesPage onOpenSignup={onOpenSignup} />
        <BrowsePage />
        <PopularMakesSection />
        <FeaturesSection />
        <DownloadSection />
        <TestimonialsSection />
        <AboutUsPage />
        <FAQPage />
        <CTASection onOpenSignup={onOpenSignup} />
      </main>

      <Footer />
    </div>
  );
};

export default Index;